import { render, staticRenderFns } from "./AboutOnlineTransactions.vue?vue&type=template&id=6a5d5fb3"
import script from "./AboutOnlineTransactions.vue?vue&type=script&lang=js"
export * from "./AboutOnlineTransactions.vue?vue&type=script&lang=js"
import style0 from "./AboutOnlineTransactions.vue?vue&type=style&index=0&id=6a5d5fb3&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports